import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { TypeaheadInput, TypeaheadInputParams } from 'portcall/typeahead/view';

export const UserSelectorView = SuperCritical((params : TypeaheadInputParams ) =>
    <div className="user-selector">
        <TypeaheadInput {...params} />
    </div>);


// WEBPACK FOOTER //
// ./apps/portcall/userselector/view.tsx